module.exports = __webpack_public_path__ + "15fe11c4.png";